<template>
  <div>
    <PageBanner 
      title="Contact Us" 
      imageSrc="../assets/images/rice-7176354_1280.jpg" 
      altText="Contact Us Banner" 
    />
    <ContactForm />
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue';
import ContactForm from '@/components/ContactForm.vue';


export default {
  name: "ContactView",
  components: {
    PageBanner,
    ContactForm
  },
};
</script>
